import constants from '@/constants'
import axios from "axios";

const parseCity = (geoData) => {
    let components = geoData.components;

    let country = components.country === 'РФ' ? 'Россия' : components.country;

    let name = country || 'Страна не указана';

    if (!!components.state)
        name += ', ' + components.state;

    let city;
    if (!!components.city)
        city = components.city;
    else if (!!components.town)
        city = components.town;
    else if (!!components.village)
        city = components.village;
    else if (!!components.hamlet)
        city = components.hamlet;
    else if (!!components.locality)
        city = components.locality;
    else if (!!components.state_district)
        city = components.state_district;
    else if (!!components.city_district)
        city = components.city_district;

    if (!!components.county
            // например, city = "Казань", county = "городской округ Казань" => county не включаем
            && components.county.indexOf(city) == -1)
        name += ', ' + components.county;

    if (!!city
            && (!components.state || components.state !== city)) {
        name += ', ' + city;
    }

    return {
        name: name,
        lat: geoData.geometry.lat,
        lng: geoData.geometry.lng
    }
};

const indexOfType = (geoData) => {
    return constants.openCage.allowedTypes.indexOf(geoData.components._type);
};

export default {
    namespace: true,
    state: {},

    actions: {
        async loadCitiesByName({commit}, city) {
            if (!city)
                return [];

            let url = constants.openCage.url
                    + '?'
                    + 'key=' + constants.openCage.key
                    + '&no_annotations=1'
                    + '&limit=10'
                    + '&language=ru'
                    + '&q=' + encodeURIComponent(city);

            try {
                const response = await axios.get(url);
                let geoData = response.data.results;
                let cities = geoData.length > 0 ? geoData
                        .filter(geoData => indexOfType(geoData) != -1)
                        // Сортируем по приоритету типа объекта (к примеру, города первыми)
                        .sort((gd1, gd2) => indexOfType(gd1) - indexOfType(gd2))
                        // Форматируем название города
                        .map(geoData => parseCity(geoData))
                        .filter(output => !!output.name)
                        // Избавляемся от дубликатов по name
                        .filter((elem, pos, arr) => arr.map((e) => e.name).indexOf(elem.name) == pos): [];

                return cities;
            } catch (error) {
                alert('При обращении к API геокодера произошла ошибка');
                console.log(error);
            }
        }
    },

    mutations: {},

    getters: {}
};